import { render, staticRenderFns } from "./PendingInvites.vue?vue&type=template&id=381c24ce&scoped=true&lang=pug"
import script from "./PendingInvites.vue?vue&type=script&lang=js"
export * from "./PendingInvites.vue?vue&type=script&lang=js"
import style0 from "./PendingInvites.vue?vue&type=style&index=0&id=381c24ce&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381c24ce",
  null
  
)

export default component.exports